import React, { useContext, useEffect, useRef, useState } from "react";
import NotesService from "../../../../services/notes.service";
import Toasts from "../../../../components/notificacion/Toasts";
import {StateContext} from "../../../../components/context/StateProvider";
import OrderService from "../../../../services/order.service";
import ModalIncidencia from "../../../incidencias/components/modals/ModalIncidencia";
import ReactToPrint from "react-to-print";
import TicketsPreparacion from "./TicketsPreparacion";
import OrderStates from "../../../../utils/OrderStates";
import Utils from "../../../../utils/Utils";
import {
    Box,
    Grid,
    Button
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import {
    INCIDENCIA_ORIGEN,
    INCIDENCIA_TIPO,
    INCIDENCIA_ESTADO_VALOR,
    ORDER_ACTION,
    ORDER_TYPE,
    ORDER_STATE
} from "../../../../config/constants";
import AuthService from "../../../../services/auth.service";
import StickerService from "../../../../services/sticker.service";
import {OrderType} from "../../../../models/Order";
import PrintSticker from "../../../../components/sticker/PrintSticker";
import PrintStickerAsigna from "../../../../components/sticker/PrintStickerAsigna";
import UsuariosService from "../../../../services/usuarios.service";
import { PeticionesRelacionadas } from "../../../peticiones";
import InformacionPedido from "./InformacionPedido";
import DetallesRuta from "./DetallesRuta";
import ImagenesOrden from "./ImagenesOrden";
import { ModalEtiquetaRuta } from "../modals";
import { debeIniciarPreparacion } from "../../helpers/estadoPreparacionN2";

// Constantes internas del componente
const SIN_ASIGNAR = '0';
const DEBOUNCE_CAMARA = 1000;

const FIELD_TYPE = {
    PREPARER: 'preparer',
    REVIEWER: 'reviewer',
    CAMERA: 'camera',
    LOCATION: 'location',
    IMAGENES: 'imagenes',
    ORDER_STATE: 'orderState',
    ORDER_STATE_N2: 'orderStateN2'
};

const FIELD_LABELS = {
    PREPARER: 'preparador',
    REVIEWER: 'revisor',
    CAMERA: 'cámara',
    LOCATION: 'localización',
    IMAGENES: 'imágenes',
    STATE: 'estado'
};

/**
 * Iniciar array de opciones de select
 */
const initSelects = (texto, employees, label = true) => {

    let employeesMap;

    if (label) {
        employeesMap = employees.map((employee) => {
            return {label: employee.nombre, value: employee.nombre.toLowerCase()}
        });
    } else {
        employeesMap = employees.map((employee) => {
            return {label: employee.nombre, value: employee.id}
        });
    }

    employeesMap.unshift({label: texto, value: SIN_ASIGNAR});
    return employeesMap;
};

const InfoOrder = (props) => {

    const {state, updateState} = useContext(StateContext);
    const {type, order, read, refDiv, orderStateN2, preparer, reviewer, camera} = props;

    // Datos cargados en el montaje
    const [reviewers, setReviewers] = useState([]);
    const [preparers, setPreparers] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [orderState, setOrderState] = useState([]);
    // Se calcula una sola vez, como hacía el constructor
    const [orderStateOptions] = useState(() => OrderStates.getStatesJsonRole(AuthService.getUserRoles()));

    // Modal de incidencia
    const [showNote, setShowNote] = useState(false);
    const [currentNote, setCurrentNote] = useState(undefined);
    const [modalNoteMode, setModalNoteMode] = useState(0);
    const [text, setText] = useState('');
    // La clase guardaba también un `title` que nunca llegaba a leerse en el render; al
    // pasar a useState quedaba como variable sin usar, así que se retira

    // Etiqueta / sticker
    const [print, setPrint] = useState([]);
    const [showAddToRoute, setShowAddToRoute] = useState(false);

    // Nunca cambia en todo el ciclo de vida; era estado en la clase pero se dejaba en 0
    const modalNoteAdmin = 0;

    const cameraRef = useRef(null);
    const stickerAsignaRef = useRef(null);
    const componentRef = useRef(null);
    const componentStickerRef = useRef(null);
    const componentStickerPrintRef = useRef(null);
    const timeoutRef = useRef(null);

    const currentOrderNumRef = useRef(null); // Para detectar cambios de pedido
    const isMountedRef = useRef(false);
    const esPrimerRender = useRef(true);
    // Sustituye el `setState(..., callback)` de printSticker, que no existe en hooks
    const imprimirTrasActualizarRef = useRef(false);

    // El contexto se lee por ref porque varias continuaciones asíncronas (la carga de
    // empleados, el debounce de cámara, los .then de las asignaciones) viven más que el
    // render en que nacieron: con el closure verían el estado congelado, mientras que la
    // clase leía this.context en el momento de la llamada.
    const estadoRef = useRef(state);
    estadoRef.current = state;

    /**
     * ¿Se puede persistir una asignación con el pedido que hay ahora en contexto?
     * El endpoint estándar exige formato SERIE-ALBARAN. Los grupos no lo cumplen (su num es
     * un id numérico) pero aportan el override onAssignToOrder, que sí admite ese identificador.
     */
    const puedePersistirAsignacion = () => {
        return Boolean(props.onAssignToOrder) || Utils.checkOrder(estadoRef.current.order?.num);
    };

    const assignToOrder = (reviewerValue, preparerValue, orderAction, n2, orderStateValue, cameraValue, location, texto, fieldType, imagenes) => {

        const estadoActual = estadoRef.current;

        // Si existe un override, usarlo en lugar del servicio normal
        const assignPromise = props.onAssignToOrder
            ? props.onAssignToOrder(estadoActual.order.num, reviewerValue, preparerValue, orderAction, orderStateValue, n2, undefined, estadoActual.year, cameraValue, props.type, location, imagenes, fieldType)
            : OrderService.assignToOrder(estadoActual.order.num, reviewerValue, preparerValue, orderAction, orderStateValue, n2, undefined, estadoActual.year, cameraValue, props.type, location, imagenes);

        assignPromise.then(
            (data) => {
                const estado = estadoRef.current;
                const toasts = Toasts.generateToast('Asignado ' + texto + ' al pedido', 'success');
                updateState({toasts: [...estado.toasts, toasts]});

                if (fieldType === FIELD_TYPE.PREPARER) {
                    estado.order.preparer = preparerValue;
                } else if (fieldType === FIELD_TYPE.REVIEWER) {
                    estado.order.reviewer = reviewerValue;
                } else if (fieldType === FIELD_TYPE.CAMERA) {
                    estado.order.editing = false;
                } else if (fieldType === FIELD_TYPE.LOCATION) {
                    estado.order.location = location;
                } else if (fieldType === FIELD_TYPE.IMAGENES) {
                    estado.order.imagenes = data.imagenes;
                } else {
                    estado.order.state = orderStateValue;
                }

                if ((estado.order.camera === null || estado.order.camera === '') && estado.order.reviewer !== SIN_ASIGNAR && estado.order.preparer !== SIN_ASIGNAR) {
                    cameraRef.current?.focus();
                }

                updateState({order: estado.order});
            }
        ).catch((error) => {
            const estado = estadoRef.current;
            const toasts = Toasts.generateToast(error.response?.data?.message, 'error');
            updateState({toasts: [...estado.toasts, toasts]})
        });
    };

    /**
     * Gestionar cambio de selects
     */
    const handleChange = (value, fieldType, orderAction, n2) => {

        const estadoActual = estadoRef.current;

        let preparerValue = null;
        let reviewerValue = null;
        let orderStateValue = null;
        let cameraValue = null;
        let location = null;
        let texto = '';
        let imagenes = [];
        if (fieldType === FIELD_TYPE.PREPARER) {
            preparerValue = value;
            texto = FIELD_LABELS.PREPARER;
        } else if (fieldType === FIELD_TYPE.REVIEWER) {
            reviewerValue = value;
            texto = FIELD_LABELS.REVIEWER;
            // DECISION: en compras el revisor no arrastra estado. Los estados de compras
            // (SIN_INICIAR, EN_PROCESO, COMPLETO, RECEPCIONADO) no son los de ventas y el
            // backend responde 400 a un '1' o un '4'.
            if (orderAction !== ORDER_ACTION.COMPRAS) {
                // "Sin asignar" viaja como la CADENA '0', no como el cero numérico: comparar
                // contra 0 dejaba el pedido EN_REVISION al quitarle el revisor, es decir, en
                // revisión sin nadie revisando
                if (String(value) !== '0') {
                    orderStateValue = ORDER_STATE.EN_REVISION;
                } else {
                    orderStateValue = ORDER_STATE.SIN_PREPARAR;
                }
                estadoActual.order.state = orderStateValue;
                updateState({order: estadoActual.order});
            }
        } else if (fieldType === FIELD_TYPE.CAMERA) {
            cameraValue = value;
            texto = FIELD_LABELS.CAMERA;
            estadoActual.order.camera = value;
            estadoActual.order.editing = true;
            updateState({order: estadoActual.order});
        } else if (fieldType === FIELD_TYPE.LOCATION) {
            estadoActual.order.location = value;
            location = value;
            texto = FIELD_LABELS.LOCATION;
            updateState({order: estadoActual.order});
        } else if (fieldType === FIELD_TYPE.IMAGENES) {
            imagenes = value;
            texto = FIELD_LABELS.IMAGENES;
        } else {
            orderStateValue = value;
            texto = FIELD_LABELS.STATE;
        }

        if (fieldType !== FIELD_TYPE.CAMERA) {
            assignToOrder(reviewerValue, preparerValue, orderAction, n2, orderStateValue, cameraValue, location, texto, fieldType, imagenes);
        } else {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                assignToOrder(reviewerValue, preparerValue, orderAction, n2, orderStateValue, cameraValue, location, texto, fieldType, imagenes)
            }, DEBOUNCE_CAMARA);
        }
    };

    /**
     * Auto-asignar revisor si orderStateN2 es false, no es modo lectura, el usuario logueado está en la lista y no hay revisor asignado
     */
    const autoAsignarRevisor = (reviewersData, usuarioLogueado) => {
        const estadoActual = estadoRef.current;

        if (!puedePersistirAsignacion()) {
            return;
        }

        const revisorEncontrado = reviewersData.find(r => r.value === usuarioLogueado);
        const autoAssignReviewer = props.autoAssignReviewer !== undefined ? props.autoAssignReviewer : true;
        if (autoAssignReviewer
            && !props.orderStateN2
            && !props.read
            && ((props.order === ORDER_ACTION.VENTAS && estadoActual.order.preparer && estadoActual.order.preparer !== SIN_ASIGNAR) || props.order === ORDER_ACTION.COMPRAS)
            && revisorEncontrado && (!estadoActual.order.reviewer || estadoActual.order.reviewer === SIN_ASIGNAR)) {
            // Asignar revisor
            estadoActual.order.reviewer = revisorEncontrado.value;

            // Actualizar contexto para forzar re-render
            updateState({order: estadoActual.order});

            // Persistir en backend
            handleChange(revisorEncontrado.value, 'reviewer', props.order, props.orderStateN2);
        }
    };

    /**
     * Auto-asignar preparador si orderStateN2 es true, no es modo lectura, el usuario logueado está en la lista y no hay preparador asignado
     */
    const autoAsignarPreparador = (preparersData, usuarioLogueado) => {
        const estadoActual = estadoRef.current;

        if (!puedePersistirAsignacion()) {
            return;
        }

        const preparadorEncontrado = preparersData.find(p => p.value === usuarioLogueado);
        if (props.orderStateN2
            && !props.read
            && preparadorEncontrado
            && (!estadoActual.order.preparer || estadoActual.order.preparer === SIN_ASIGNAR)) {
            // Asignar preparador
            estadoActual.order.preparer = preparadorEncontrado.value;

            // Actualizar contexto para forzar re-render
            updateState({order: estadoActual.order});

            // Persistir en backend
            handleChange(preparadorEncontrado.value, 'preparer', props.order, props.orderStateN2);
        }
    };

    // Las auto-asignaciones se invocan desde el efecto de montaje, que solo corre una vez:
    // sin esta ref usarían las props y los handlers del primer render. La clase las
    // resolvía como métodos, es decir, siempre la versión vigente.
    const autoAsignarRef = useRef(null);
    autoAsignarRef.current = {autoAsignarRevisor, autoAsignarPreparador};

    useEffect(() => {
        isMountedRef.current = true;

        const cargarEmpleados = async () => {
            // DECISION: capturar el pedido con el que se monta. listarUsuariosMap es asíncrono y,
            // al cambiar de página, este componente puede haberse desmontado (o el contexto haber
            // cambiado de pedido) antes de que resuelva. Sin estas comprobaciones se auto-asignaba
            // el revisor contra el pedido anterior, p.ej. el id de grupo al volver de OrderN2Grupo.
            const orderNumAlMontar = estadoRef.current.order?.num;

            const empleados = await UsuariosService.listarUsuariosMap();

            if (!isMountedRef.current) {
                return;
            }

            const user = AuthService.getCurrentUser();
            const usuarioLogueado = user?.username?.toLowerCase() || '';

            const preparersData = initSelects('Elige preparador', empleados);
            const reviewersData = initSelects('Elige revisor', empleados);

            setPreparers(preparersData);
            setReviewers(reviewersData);
            setOrderState(OrderStates.getStatesJson());
            setEmployees(empleados);

            // El pedido cambió mientras se cargaban los empleados: no auto-asignar contra el viejo.
            // currentOrderNum se queda a null a propósito para que el efecto de actualización lo
            // haga con el pedido nuevo en cuanto esté disponible.
            if (estadoRef.current.order?.num !== orderNumAlMontar) {
                return;
            }

            // Auto-asignar revisor y preparador
            currentOrderNumRef.current = estadoRef.current.order?.num;
            autoAsignarRef.current.autoAsignarRevisor(reviewersData, usuarioLogueado);
            autoAsignarRef.current.autoAsignarPreparador(preparersData, usuarioLogueado);
        };

        cargarEmpleados();

        return () => {
            isMountedRef.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Equivalente a componentDidUpdate: corre tras cada render (nunca tras el montaje) y
    // reasigna cuando el contexto trae otro pedido. El guard de currentOrderNumRef evita
    // que el updateState de la propia asignación lo vuelva a disparar.
    useEffect(() => {
        if (esPrimerRender.current) {
            esPrimerRender.current = false;
            return;
        }

        const numActual = estadoRef.current.order?.num;

        if (numActual && numActual !== currentOrderNumRef.current) {
            currentOrderNumRef.current = numActual;
            const user = AuthService.getCurrentUser();
            const usuarioLogueado = user?.username?.toLowerCase() || '';
            if (reviewers && reviewers.length > 0) {
                autoAsignarRevisor(reviewers, usuarioLogueado);
            }
            if (preparers && preparers.length > 0) {
                autoAsignarPreparador(preparers, usuarioLogueado);
            }
        }
    });

    // Sustituye al callback del setState de printSticker: disparar la impresión solo
    // cuando el sticker nuevo ya está aplicado
    useEffect(() => {
        if (imprimirTrasActualizarRef.current) {
            imprimirTrasActualizarRef.current = false;
            componentStickerPrintRef.current?.handleClick();
        }
    }, [print]);

    const setComponentRef = (ref) => {
        componentRef.current = ref;
    };

    const reactToPrintContent = () => {
        return componentRef.current;
    };

    const setComponentStickerRef = (ref) => {
        componentStickerRef.current = ref;
    };

    const setComponentStickerPrintRef = (ref) => {
        componentStickerPrintRef.current = ref;
    };

    const reactToStickerPrintContent = () => {
        return componentStickerRef.current;
    };

    const printSticker = async (etiqueta, deliveryObject) => {
        const estadoActual = estadoRef.current;

        if (deliveryObject && (deliveryObject.asigna || deliveryObject.msoft) && !estadoActual.order?.sticker?.expedicionAsigna) {
            await stickerAsignaRef.current.printSticker(etiqueta, deliveryObject);
        }

        imprimirTrasActualizarRef.current = true;
        setPrint(etiqueta);
    };

    const handleNote = async (e, orderActual) => {

        let noteNum = Utils.getOrder(orderActual.num);

        let tipo_note = INCIDENCIA_TIPO.ALB;

        if (typeof noteNum.serie === 'undefined') {
            tipo_note = INCIDENCIA_TIPO.PED
        }

        let modalNote = {};
        let invoice = null;
        const notaActual = orderActual.Note

        if(notaActual === undefined || notaActual.albaran === undefined){
            modalNote = {
                serie: noteNum.serie,
                albaran: noteNum.order,
                id_empleado: orderActual.employee,
                nombre_empleado: '',
                estado: INCIDENCIA_ESTADO_VALOR.ABIERTA,
                // En Nave 2 las incidencias tienen origen propio para no pisar las de ventas
                origen: (props.orderStateN2
                    ? INCIDENCIA_ORIGEN.NAVE2
                    : (tipo_note === INCIDENCIA_TIPO.ALB ? INCIDENCIA_ORIGEN.SALES : INCIDENCIA_ORIGEN.PURCHASES)),
                note: '',
                modificado: Date.now(),
                creado: Date.now(),
                comentarios: [],
                id_note: 0,
                tipo_note: tipo_note
            }
        }else{
            modalNote = notaActual;
            invoice = await NotesService.getInfoInvoice(noteNum.serie?.trim(),noteNum.order?.trim(), estadoRef.current.year);
            if (invoice.length > 0) {
                modalNote.cliente = invoice.ClientesModel.CODIGO + ' \ ' + invoice.ClientesModel.NOMBRE;
                modalNote.factura = invoice.FACTURA;
            }
        }

        setShowNote(true);
        setCurrentNote(modalNote);
        setModalNoteMode(0);
        setText('Datos de la incidencia: <strong>'+ (modalNote.serie ? modalNote.serie.trim() + '-' : '') + modalNote.albaran.trim() +'</strong><br>' + (modalNote.cliente || '') + (modalNote.factura ? ' Factura: ' + modalNote.factura : ''));
    };

    const handleConfirmNote = async (modalNote) => {

        const estadoActual = estadoRef.current;
        let Note = currentNote;

        //Si Note existe, actualizamos y creamos como comentario añadido
        //Si no existe creamos nueva note + comentario
        if(Note && Note.id_note){
            NotesService.registerNotesComentarios(modalNote).then(
                (resp) => {

                    Note.comentarios.push(resp.data)
                    NotesService.updateNote(modalNote).then(
                        async (resp) => {

                            const estado = estadoRef.current;
                            let toasts = Toasts.generateToast(resp.message, 'success');
                            updateState({toasts: [...estado.toasts, toasts]});

                            setShowNote(false);

                            const notaActualizada = await NotesService.getNoteByNum(Note.serie, Note.albaran, Note.origen);

                            // Solo las incidencias de etiqueta (STICKER) tienen sticker y reimprimen;
                            // ventas y compras guardan la incidencia en el pedido/albarán
                            if (modalNote.origen === INCIDENCIA_ORIGEN.STICKER && estado.order.sticker) {
                                estado.order.sticker.Note = notaActualizada;
                                printSticker(estado.order.sticker);
                            } else {
                                estado.order.Note = notaActualizada;
                            }

                            updateState({order: estado.order});
                        }
                    ).catch((error) => {
                        const toasts = Toasts.generateToast(error.message, 'error');
                        updateState({toasts: [...estadoRef.current.toasts, toasts]})
                    });
                }
            ).catch((error) => {
                const toasts = Toasts.generateToast(error.message, 'error');
                updateState({toasts: [...estadoActual.toasts, toasts]})
            });
        }else{

            NotesService.registerNotes(modalNote).then(
                (resp) => {

                    modalNote.id_note = resp.data.id_note
                    NotesService.registerNotesComentarios(modalNote).then(
                        async (resp) => {

                            const estado = estadoRef.current;
                            let toasts = Toasts.generateToast(resp.message, 'success');
                            updateState({toasts: [...estado.toasts, toasts]});

                            setShowNote(false);

                            const notaActualizada = await NotesService.getNoteByNum(Note?.serie, Note?.albaran, Note?.origen);

                            // Solo las incidencias de etiqueta (STICKER) tienen sticker y reimprimen;
                            // ventas y compras guardan la incidencia en el pedido/albarán
                            if (modalNote.origen === INCIDENCIA_ORIGEN.STICKER && estado.order.sticker) {
                                estado.order.sticker.Note = notaActualizada;
                                printSticker(estado.order.sticker);
                            } else {
                                estado.order.Note = notaActualizada;
                            }

                            updateState({order: estado.order});
                        }
                    ).catch((error) => {
                        const toasts = Toasts.generateToast(error.message, 'error');
                        updateState({toasts: [...estadoRef.current.toasts, toasts]})
                    });
                }
            ).catch((error) => {
                const toasts = Toasts.generateToast(error.message, 'error');
                updateState({toasts: [...estadoActual.toasts, toasts]})
            });
        }
    };

    const handleCloseNote = () => {
        setShowNote(false);
    };

    const openAddToRoute = () => {
        setShowAddToRoute(true);
    };

    const closeAddToRoute = () => {
        setShowAddToRoute(false);
    };

    const handleEtiquetaCreada = (etiqueta, deliveryObject) => {
        printSticker(etiqueta, deliveryObject);
    };

    /**
     * Abrir modal de incidencia al fallar la creación de la etiqueta.
     * Construye el objeto de incidencia a partir del sticker (puede llegar undefined
     * si el fallo ocurrió antes de crearlo) y de la nota existente en el pedido.
     */
    const handleMostrarIncidencia = (sticker, texto) => {
        const estadoActual = estadoRef.current;
        const orderNum = Utils.getOrder(estadoActual.order.num);

        const modalNote = {
            serie: sticker?.serie ?? orderNum.serie,
            albaran: sticker?.order ?? orderNum.order,
            id_empleado: sticker?.employee,
            nombre_empleado: sticker?.nameEmployee || '',
            estado: estadoActual.order?.Note?.estado ?? INCIDENCIA_ESTADO_VALOR.ABIERTA,
            origen: INCIDENCIA_ORIGEN.STICKER,
            note: estadoActual.order?.Note,
            modificado: Date.now(),
            creado: Date.now(),
            // Sin id_note: la incidencia por fallo de etiqueta siempre se crea nueva
            comentarios: sticker?.comentarios || [],
            tipo_note: INCIDENCIA_TIPO.ALB
        };

        setShowNote(true);
        setCurrentNote(modalNote);
        setModalNoteMode(0);
        setText(texto);
    };

    // eslint-disable-next-line no-unused-vars
    const handleIframeLoad = async () => {
        let sticker = print;
        if (!sticker.print) {
            sticker.print = true;
            await StickerService.registerSticker(sticker);
            const estadoActual = estadoRef.current;

            const numeroAlbaran = sticker.serie + '-' + sticker.order;

            // DECISION: pasar por onAssignToOrder cuando existe (grupos). Llamar al servicio
            // directamente marcaba solo el albarán de la etiqueta y dejaba fuera al resto de
            // pedidos del grupo y al propio grupo.
            if (props.onAssignToOrder) {
                await props.onAssignToOrder(numeroAlbaran, null, null, ORDER_ACTION.VENTAS, ORDER_STATE.PREPARADO, false, undefined, estadoActual.year, null, OrderType.Albaran.valueOf(), null, null, FIELD_TYPE.ORDER_STATE_N2);
            } else {
                await OrderService.assignToOrder(numeroAlbaran, null, null, ORDER_ACTION.VENTAS, ORDER_STATE.PREPARADO, false, undefined, estadoActual.year, null, OrderType.Albaran.valueOf(), null, null);
            }

            estadoActual.order.sticker = sticker;
        }
    };

    // Determinar si tiene detalles de ruta
    const tieneDetallesRuta = state.order.complete && state.order.delivery !== null && state.order.sticker !== null;

    return (
        <Box id='info-order' sx={{ mt: 3 }}>
            <Grid container spacing={3} sx={{ alignItems: "stretch" }}>
                    {/* Información del Pedido/Albarán */}
                    <Grid item xs={12} md={tieneDetallesRuta ? 6 : 12} sx={{ display: "flex", flexDirection: "column" }}>
                        <InformacionPedido
                            orderNum={state.order.num}
                            year={state.year}
                            orderType={props.type}
                            type={type}
                            order={order}
                            read={read}
                            orderStateN2={orderStateN2}
                            // Flags de flujo de la vista: qué campos aplican
                            aplicaPreparador={preparer}
                            aplicaRevisor={reviewer}
                            aplicaCamara={camera}
                            // Opciones para selects
                            preparadoresOpciones={preparers}
                            revisoresOpciones={reviewers}
                            estadosOpciones={orderStateOptions}
                            estadosOpcionesN2={orderState}
                            // Callbacks
                            onPreparadorChange={(value) => handleChange(value, FIELD_TYPE.PREPARER, order, orderStateN2)}
                            onRevisorChange={(value) => handleChange(value, FIELD_TYPE.REVIEWER, order, orderStateN2)}
                            onEstadoChange={(value) => handleChange(value, FIELD_TYPE.ORDER_STATE, order, orderStateN2)}
                            onEstadoN2Change={(value) => handleChange(value, FIELD_TYPE.ORDER_STATE_N2, order, orderStateN2)}
                            onCamaraChange={(value) => handleChange(value, FIELD_TYPE.CAMERA, order, orderStateN2)}
                            onLocalizacionChange={(value) => handleChange(value, FIELD_TYPE.LOCATION, order, orderStateN2)}
                            onIncidenciaClick={(e) => handleNote(e, state.order)}
                            // Refs
                            camaraRef={cameraRef}
                        />

                        {/* Botón de imprimir (para pedidos N2) */}
                        {orderStateN2 && state.order.preparer !== SIN_ASIGNAR && state.order.state !== SIN_ASIGNAR && !state.order.complete && (
                            <Box sx={{ mt: 2 }} ref={refDiv}>
                                <ReactToPrint
                                    onAfterPrint={() => {
                                        // Reimprimir un pedido ya en preparación (o en revisión) no
                                        // vuelve a asignar el estado: solo arranca lo que está sin preparar
                                        if (debeIniciarPreparacion(estadoRef.current.order.state)) {
                                            handleChange(ORDER_STATE.EN_PREPARACION, FIELD_TYPE.ORDER_STATE_N2, order, orderStateN2)
                                        }
                                    }}
                                    trigger={() => {
                                        return (
                                            <Button
                                                variant="contained"
                                                size="large"
                                                fullWidth
                                                startIcon={<PrintIcon />}
                                                sx={{
                                                    backgroundColor: "#cc071e",
                                                    "&:hover": {
                                                        backgroundColor: "#a30618"
                                                    },
                                                    py: 1.5,
                                                    fontSize: 16,
                                                    fontWeight: 600,
                                                    textTransform: "none"
                                                }}
                                            >
                                                Imprimir
                                            </Button>
                                        );
                                    }}
                                    content={reactToPrintContent}
                                />
                                {/* Ticket completo y, si hay productos en altura / Tronja 3, su etiqueta */}
                                <TicketsPreparacion ref={setComponentRef}/>
                            </Box>
                        )}
                    </Grid>

                    {/* Detalles de Ruta */}
                    {state.order.complete && (
                        <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column" }}>
                            <DetallesRuta
                                orderNum={state.order.num}
                                year={state.year}
                            />
                        </Grid>
                    )}
                </Grid>

                {/* Peticiones relacionadas - Solo en ventas y con número de albarán válido.
                    DECISION: el endpoint exige formato SERIE-ALBARAN. Sin este guard se
                    consulta con el id de grupo (OrderN2Grupo) o con el pedido residual que
                    aún queda en contexto durante el primer render al cambiar de página. */}
                {order !== ORDER_ACTION.COMPRAS && Utils.checkOrder(state.order.num) && (
                    <PeticionesRelacionadas
                        orderNum={state.order.num}
                    />
                )}

                {/* Imágenes */}
                {type === ORDER_TYPE.ALBARAN && (
                    <ImagenesOrden
                        imagenes={state.order.imagenes}
                        completo={state.order.complete}
                        permitirImagenesCompleto={props.permitirImagenesCompleto}
                        onFilesChange={(e) => handleChange(e, FIELD_TYPE.IMAGENES, order, orderStateN2)}
                    />
                )}

                {/* Botón Imprimir Etiqueta */}
                {state.order.complete && type === ORDER_TYPE.ALBARAN.valueOf() && order === ORDER_ACTION.VENTAS && (
                    <Box sx={{ mt: 3 }}>
                        <Button
                            variant="contained"
                            size="large"
                            fullWidth
                            startIcon={<PrintIcon />}
                            onClick={openAddToRoute}
                            sx={{
                                backgroundColor: "#cc071e",
                                "&:hover": {
                                    backgroundColor: "#a30618"
                                },
                                py: 1.5,
                                fontSize: 16,
                                fontWeight: 600,
                                textTransform: "none"
                            }}
                        >
                            Imprimir etiqueta
                        </Button>
                    </Box>
                )}

                {/* DECISION: Modal de incidencias migrado a Material-UI (ModalIncidencia del feature) */}

                <ModalIncidencia show={showNote}
                             text={text}
                             noteModal={currentNote}
                             modalNoteMode={modalNoteMode}
                             modalNoteAdmin={modalNoteAdmin}
                             handleClose={handleCloseNote}
                             handleConfirm={(sticker) => handleConfirmNote(sticker)} />

                {/* Modal etiqueta ruta */}
                {state.order.complete && type === ORDER_TYPE.ALBARAN.valueOf() && order === ORDER_ACTION.VENTAS && (
                    <>
                        <ModalEtiquetaRuta
                            show={showAddToRoute}
                            onClose={closeAddToRoute}
                            employees={employees}
                            onEtiquetaCreada={handleEtiquetaCreada}
                            onMostrarIncidencia={handleMostrarIncidencia}
                        />

                        <PrintSticker ref={setComponentStickerRef} print={print}/>
                        <PrintStickerAsigna ref={stickerAsignaRef}/>

                        <ReactToPrint
                            ref={setComponentStickerPrintRef}
                            content={reactToStickerPrintContent}
                            onAfterPrint={handleIframeLoad}
                        />
                    </>
                )}

        </Box>
    );
};

export default InfoOrder;
